function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { progressAnatomy as parts } from "@chakra-ui/anatomy";
import { generateStripe } from "@chakra-ui/theme-tools";
import { corePalette } from "../theme/index";
export { Progress, ProgressLabel } from "@chakra-ui/react";
function filledStyle(props) {
    const { colorScheme: c, isIndeterminate, hasStripe } = props;
    const bgColor = `${c}.500`; // TODO: how to handle those colorSchemes interpolation now?
    const gradient = `linear(to-r, transparent, ${bgColor}, transparent)`;
    const addStripe = !isIndeterminate && hasStripe;
    return _object_spread_props(_object_spread({}, addStripe && generateStripe(), isIndeterminate ? {
        bgGradient: gradient
    } : {
        bgColor
    }), {
        _dark: _object_spread({}, addStripe && generateStripe('1rem', 'rgba(0,0,0,0.1)'))
    });
}
const baseStyleLabel = {
    lineHeight: '1',
    fontSize: '0.25em',
    fontWeight: 'bold',
    color: 'white'
};
const baseStyleFilledTrack = (props)=>{
    return _object_spread({
        transitionProperty: 'common',
        transitionDuration: 'slow'
    }, filledStyle(props));
};
const baseStyle = (props)=>({
        label: baseStyleLabel,
        filledTrack: baseStyleFilledTrack(props),
        track: {
            bg: corePalette.neutral[20],
            _dark: {
                bg: corePalette.neutral[100]
            }
        }
    });
const sizes = {
    xs: {
        track: {
            h: '0.25rem'
        }
    },
    sm: {
        track: {
            h: '0.5rem'
        }
    },
    md: {
        track: {
            h: '0.75rem'
        }
    },
    lg: {
        track: {
            h: '1rem'
        }
    }
};
const defaultProps = {
    size: 'md',
    colorScheme: 'primary'
};
export const ThemedProgress = {
    parts: parts.keys,
    sizes,
    baseStyle,
    defaultProps
};

//# sourceMappingURL=Progress.js.map